<!--
 * @Description: 危险区域流入商品信息
 * @Author: WuPuyi
 * @LastEditors: WuPuyi
 * @Date: 2020-12-02 09:53:36
 * @LastEditTime: 2021-01-05 09:24:21
-->
<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        危险区域流入商品信息
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            v-if="operationSuper.导出"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.timeRange">
            <el-date-picker
              v-model="slotForms.forms.timeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="datePickerOptions"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.dangerRegionIds" class="form-item_2">
            <el-select
              v-model="slotForms.forms.dangerRegionIds"
              clearable
              filterable
              placeholder="危险区域名称"
              :loading="dangerAreaLoading"
              collapse-tags
              multiple
            >
              <el-option
                v-for="item in dangerAreaList"
                :key="item.regionId"
                :label="item.regionName"
                :value="item.regionId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.dangerLevel" class="form-item_2">
            <el-select
              v-model="slotForms.forms.dangerLevel"
              clearable
              placeholder="危险等级"
            >
              <el-option label="中危" :value="1"></el-option>
              <el-option label="高危" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->

    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          label="序号"
          width="80"
          fixed
          align="center"
          type="index"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in tableCols"
          :key="index"
          :show-overflow-tooltip="true"
          min-width="130"
          align="center"
          :fixed="item.fixable"
          :prop="item.name"
          :label="item.title"
        >
          <template slot-scope="scope">
            <span v-if="item.name === 'batchNum'">
              <el-button
                type="text"
                @click="handleGotoInflowBatch(scope.row)"
                >{{ scope.row[item.name] }}</el-button
              >
            </span>
            <span v-else>
              {{ scope.row[item.name] }}
            </span>
          </template>
        </el-table-column>
        <div slot="empty" class="figure-data">
          <div class="nodate">
            <img src="../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import { mergeFormExtend } from "_private/utils/merge";
import operationManage from "_private/mixins/operationManage";

import { datePickerOptionsNotContainToday } from "@/utils/dateUtil.js";
import { shortcuts } from "@/utils/dateUtil.js";
import {
  fetchDangerAreaList,
  fetchDangerAreaTraceList,
  exportDangerAreaTraceList
} from "@/api/goodsTrace/dangerGoodsInflow";
import { cloneDeep } from "lodash";
import moment from "moment";
import { exportXlsx } from "@/utils/exportXlsx";

export default {
  mixins: [resizeListener, operationManage],
  data() {
    return {
      total: 0, // 总条数
      curPage: 1, // 当前页码
      pageSize: 20, // 每页条目数
      isSearch: false, // 是否展示搜索栏
      datePickerOptions: {
        shortcuts: shortcuts({ d: [0, -1, -2, -7, -30] }, true, 2)
      }, // 时间快捷选择
      dangerAreaList: [], // 高危区域列表
      dangerAreaLoading: false, // 高危区域 loading
      formExtend: {
        forms: {
          timeRange: [
            moment()
              .startOf("day")
              .format("YYYY-MM-DD HH:mm:ss"),
            moment()
              .endOf("day")
              .format("YYYY-MM-DD HH:mm:ss")
          ], // 时间
          dangerRegionIds: [],
          dangerRegion: [],
          dangerLevel: "",
          startTime: "",
          endTime: ""
        },
        extends: []
      },
      tableData: [], // 表格数据
      columSetVisible: false, // 表格列设置
      showTableCols: [],
      hideTableCols: [],
      copyShowTableCols: [],
      copyHideTableCols: [],
      localShowTableCols: [],
      multipleSelection: [],
      loading: false, // 表格 loading
      tableCols: [
        {
          fixable: "left",
          name: "regionName",
          show: true,
          title: "危险地区"
        },
        {
          fixable: "left",
          name: "dangerTime",
          show: true,
          title: "危险时间段"
        },
        {
          fixable: "left",
          name: "dangerLevelStr",
          show: true,
          title: "危险等级"
        },
        {
          fixable: "left",
          name: "batchNum",
          show: true,
          title: "商品批次数"
        },
        {
          fixable: "left",
          name: "categoryNum",
          show: true,
          title: "商品类型数"
        },
        {
          fixable: "left",
          name: "storageCompanyNum",
          show: true,
          title: "涉及园区服务企业数量"
        },
        {
          fixable: "left",
          name: "foodCompanyNum",
          show: true,
          title: "涉及商家数量"
        }
      ]
    };
  },
  watch: {
    "formExtend.forms.timeRange": {
      immediate: true,
      handler(val) {
        this.formExtend.forms.startTime = val[0];
        this.formExtend.forms.endTime = val[1];
      }
    },
    "formExtend.forms.dangerRegionIds": {
      handler(val) {
        let result = [];
        this.dangerAreaList.forEach(area => {
          if (val.includes(area.regionId)) {
            result.push(area);
          }
        });

        this.formExtend.forms.dangerRegion = result;
      }
    }
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"])
  },
  created() {
    console.log(this.searchFormIsOpen);
    // 危险区域列表
    this.queryDangerAreaList();
    // 请求列表数据
    this.FetchFindByPage(this.mergeObj());
    this.setSearchFormIsOpenAct();
  },

  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),

    // 获取危险区域名称
    async queryDangerAreaList() {
      try {
        this.dangerAreaLoading = true;
        let res = await fetchDangerAreaList();
        if (res.code === 1 && Array.isArray(res.result)) {
          this.dangerAreaList = cloneDeep(res.result);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.dangerAreaLoading = false;
      }
    },

    // 导出数据
    async exportData() {
      try {
        let res = await exportDangerAreaTraceList(this.mergeObj());
        let time = moment().format("YYYYMMDDHHmmss");
        exportXlsx(res, `危险区域流入商品信息${time}.xlsx`);
      } catch (error) {
        console.log(error);
      }
    },

    // 获取表格数据
    async FetchFindByPage(data) {
      try {
        this.loading = true;
        let res = await fetchDangerAreaTraceList(data);
        if (res.result && res.result.data && Array.isArray(res.result.data)) {
          this.tableData = res.result.data;
          this.total = res.result.totalRecords;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    // 选择表格列
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },
    //重置
    handleResetForm() {
      this.formExtend.forms.timeRange = [
        moment()
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        moment()
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
      ]; // 时间
      this.formExtend.forms.dangerRegionIds = []; // 危险区域名称选择列表
      this.formExtend.forms.dangerLevel = ""; // 危险等级
    },
    // 导出
    handleExportClick() {
      this.exportData();
    },
    // 跳转到流入批次信息
    handleGotoInflowBatch(row) {
      let warehouseIdList = row.warehouseIdList ? row.warehouseIdList : [];
      let route = this.$router.resolve({
        path: "/goodsTraceInflowBatch",
        query: {
          startTime: this.formExtend.forms.startTime,
          endTime: this.formExtend.forms.endTime,
          inWarehouseId: JSON.stringify(warehouseIdList)
        }
      });

      window.open(route.href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
.form-section {
  .form-extend {
    .form-item_2 {
      /deep/ .el-form-item__content {
        width: 200px;
        .el-select {
          width: 200px;
        }
      }
    }
  }
}
</style>
